import Stories from "./Stories.container.view";

export default Stories;